/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './front-content-marketplace.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../shared/partica/partica.component.ngfactory';
import * as i3 from '../../../../app/shared/partica/partica.component';
import * as i4 from '../../../../app/app.config';
import * as i5 from '../../../../app/services/auth.service';
import * as i6 from '../../../../app/services/partica.service';
import * as i7 from '../../../../app/front/front-content-marketplace/front-content-marketplace.component';
import * as i8 from '../../../../app/front/front.service';
const styles_FrontContentMarketplaceComponent:any[] = [i0.styles];
export const RenderType_FrontContentMarketplaceComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_FrontContentMarketplaceComponent,data:{}});
export function View_FrontContentMarketplaceComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-partica',
      [['page','home']],(null as any),(null as any),(null as any),i2.View_ParticaComponent_0,
      i2.RenderType_ParticaComponent)),i1.ɵdid(1,245760,(null as any),0,i3.ParticaComponent,
      [i4.APP_CONFIG,i5.AuthService,i6.ParticaService,i1.ChangeDetectorRef],{page:[0,
          'page']},(null as any))],(_ck,_v) => {
    const currVal_0:any = 'home';
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_FrontContentMarketplaceComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-front-content-marketplace',
      ([] as any[]),(null as any),(null as any),(null as any),View_FrontContentMarketplaceComponent_0,
      RenderType_FrontContentMarketplaceComponent)),i1.ɵdid(1,114688,(null as any),
      0,i7.FrontContentMarketplaceComponent,[i8.FrontService],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const FrontContentMarketplaceComponentNgFactory:i1.ComponentFactory<i7.FrontContentMarketplaceComponent> = i1.ɵccf('app-front-content-marketplace',
    i7.FrontContentMarketplaceComponent,View_FrontContentMarketplaceComponent_Host_0,
    {},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC9mcm9udC1jb250ZW50LW1hcmtldHBsYWNlL2Zyb250LWNvbnRlbnQtbWFya2V0cGxhY2UuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC9mcm9udC1jb250ZW50LW1hcmtldHBsYWNlL2Zyb250LWNvbnRlbnQtbWFya2V0cGxhY2UuY29tcG9uZW50LnRzIiwibmc6Ly8vdmFyL3d3dy9odG1sL015RGVzaWduVjMvaHRtbC9zcmMvYXBwL2Zyb250L2Zyb250LWNvbnRlbnQtbWFya2V0cGxhY2UvZnJvbnQtY29udGVudC1tYXJrZXRwbGFjZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC9mcm9udC1jb250ZW50LW1hcmtldHBsYWNlL2Zyb250LWNvbnRlbnQtbWFya2V0cGxhY2UuY29tcG9uZW50LnRzLkZyb250Q29udGVudE1hcmtldHBsYWNlQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGFwcC1wYXJ0aWNhIHBhZ2U9XCJob21lXCI+PC9hcHAtcGFydGljYT4iLCI8YXBwLWZyb250LWNvbnRlbnQtbWFya2V0cGxhY2U+PC9hcHAtZnJvbnQtY29udGVudC1tYXJrZXRwbGFjZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtvQ0FBQSxVQUFBO01BQUE7VUFBQTtJQUFhO0lBQWIsV0FBYSxTQUFiOzs7O29CQ0FBO01BQUE7aURBQUEsVUFBQTtNQUFBOztRQUFBOzs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/front/front-content-marketplace/front-content-marketplace.component.ngfactory.ts